import React from 'react'

export const HostSignUpPage = ({ loginBoxComponent, signUpFormComponent }) => {
  return (
    <div className="page__even lp-page__padding">
      <div className="page__col1">
        <div className="signup-head">
          <h1 className="page-title">{i18n.t('page.account.l_00041')}</h1>
        </div>
        {loginBoxComponent}
        {signUpFormComponent}
      </div>
    </div>
  )
}
